import { render, staticRenderFns } from "./HelpMessages.vue?vue&type=template&id=beca7d76&"
import script from "./HelpMessages.vue?vue&type=script&lang=ts&"
export * from "./HelpMessages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports